import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Icon } from '../../ui-kit';
import { MODERATED, BANNED } from '../../services/companies-statuses';
import './styles.scss';

const CompanyBadge = (props) => (
  <section className="companies_item__container">
    <div className="companies_item">
      {(props.status === BANNED || props.status === MODERATED)
        && props.showBadges && (
          <div
            className={`companies_status ${
              props.status === BANNED ? 'companies_status_danger' : ''
            } ${
              props.status === MODERATED ? 'companies_status_moderated' : ''
            }`}
          >
            {props.status === BANNED && 'Banned'}
            {' '}
            {props.status === MODERATED && 'Moderated'}
          </div>
      )}
      <div className="companies_item_name_phone__container">
        <div className="companies_item_image__container">
          <div
            style={{
              backgroundImage: `url(${props.logo?.uri ? props.logo.uri : require('../../images/background.png')})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            }}
            className="companies_item_background"
          />
          {props.logo ? (
            <div
              className="companies_item_image"
              style={{
                backgroundImage: `url(${props.logo.uri})`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
              }}
            />
          ) : (
            <div className="companies_item_image">
              <Icon name="camera" width="2em" height="2em" />
            </div>
          )}
        </div>
        <Link to={`/company#${props.companyId}`} className="companies_item_name">{props.name}</Link>
        <p className="companies_item_phone">{props.phone}</p>
      </div>
      <div className="companies_item_buttons__container">
        <Link to={`/user#${props.uid}`}>
          <Icon name="person-filled" />
        </Link>
        {props.status !== BANNED && (
          <button
            className="companies_item_button"
            onClick={() => {
              if (window.confirm('Are you sure that you want decline this company?')) {
                props.banCompany();
              }
            }}
          >
            <Icon name="eye-slash" />
          </button>
        )}
        {(props.status === BANNED || props.status === MODERATED)
          && props.acceptCompany && (
            <button
              className="companies_item_button"
              onClick={() => {
                if (window.confirm('Are you sure that you want accept this company?')) {
                  props.acceptCompany();
                }
              }}
            >
              <Icon name="check-filled" />
            </button>
        )}
      </div>
    </div>
  </section>
);

CompanyBadge.propTypes = {
  logo: PropTypes.string,
  name: PropTypes.string,
  uid: PropTypes.string,
  phone: PropTypes.string,
  link: PropTypes.string,
  acceptCompany: PropTypes.func,
  status: PropTypes.string,
  banCompany: PropTypes.func,
  showBadges: PropTypes.bool,
  location: PropTypes.string,
  companyId: PropTypes.string,
};
CompanyBadge.defaultProps = {
  companyId: '',
  logo: '',
  name: '',
  uid: '',
  phone: '',
  link: '',
  acceptCompany: null,
  banCompany: null,
  status: null,
  showBadges: false,
  location: null,
};

export default CompanyBadge;
